import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd-v5';
import PropTypes from 'prop-types';
import ContactMethodFilter from './components/ContactMethodFilter';

const ContactMethodFilterModal = ({ open, onClose, value, onApply }) => {
  const [localValue, setLocalValue] = useState([]);

  useEffect(() => {
    if (open) {
      setLocalValue(value || []);
    }
  }, [open, value]);

  const handleApply = () => {
    onApply(localValue);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Contact Methods"
      footer={null}
      className="audience-filter-modal"
      width={480}
      centered
    >
      <div style={{ padding: '8px 0 16px' }}>
        <ContactMethodFilter value={localValue} onChange={setLocalValue} />
      </div>
      <div className="audience-filter-modal__footer">
        <Button
          type="link"
          onClick={() => setLocalValue([])}
          disabled={localValue.length === 0}
        >
          Clear
        </Button>
        <div className="audience-filter-modal__footer-right">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ContactMethodFilterModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  onApply: PropTypes.func.isRequired,
};

ContactMethodFilterModal.defaultProps = {
  value: [],
};

export default ContactMethodFilterModal;
